import { combineReducers } from 'redux';

export function error(state = null, action) {
    switch (action.type) {
        case 'USER_SHOW_ERROR':
            return action.error;

        case 'USER_SHOW_RESET':
            return null;

        default:
            return state;
    }
}

export function retrieved(state = null, action) {
    switch (action.type) {
        case 'USER_SHOW_SUCCESS':
            return action.retrieved;

        case 'USER_SHOW_RESET':
            return null;

        default:
            return state;
    }
}

export default combineReducers({ error, retrieved });
